let orbitDefaults = {
  server_address: "wildfly.orbit.local",
  //server_address: `https://dev.ots13.com:443/cash/Authentication`;
  server_port: "8443",
  server_path: "/cash/",
  client_id: "12388080",
};

export default orbitDefaults;
